const resultModalOk: HTMLButtonElement = document.querySelector('#resultModalOk')
const resultModalShowButton: HTMLButtonElement = document.querySelector('.resultModalShowButton')
export const dispResultModal = (title, body, reload) => {
    resultModalShowButton.click()
    document.getElementById('resultModalTitle').innerText = title;
    document.getElementById('resultModalBody').innerText = body;
    if (reload === true) {
        // modalメッセージのOKボタンが押されたらページをリロードをする。
        resultModalOk.onclick = (e) => {
            dispLoading('ページを更新します。');
            location.reload();
        }
    }
}


const loadingEl: HTMLElement = document.querySelector('#loading')
const loadingMessage: HTMLElement = document.querySelector('#loadingMsgContent')

// loadingスピナーの表示非表示切り替え
// html不要。表示レイアウトなどはoriginal.cssに記述
export const dispLoading = (msg) => {
    if (msg == undefined) {
        msg = "";
    }
    // 画面表示メッセージ
    loadingMessage.innerText = msg
    loadingEl.style.display = 'table'
}

export const removeLoading = () => {
    loadingEl.style.display = 'none'
}


// 別ウインドウを開くイベントをキャッチし、removeLoadingを実行
window.addEventListener('focusout', (e) => {
    removeLoading();
});
// new WOW().init();